<template>
<v-form ref="form1" data-vv-scope="form1">
    <v-layout wrap>
        <v-flex xs12 sm12 md12>
            <v-text-field prepend-icon="fa fa-user-o" ref="fullName" v-model="payer.full_name" v-validate="'required'" :error-messages="errors.collect('payer.full_name')" :label="$t('message.full_name')" data-vv-name="payer.full_name" required>
                <template slot="append-outer" name="full_name_slot">
                    <v-icon v-show="payer.full_name===undefined?true:(payer.full_name.length>0?false:true)">fa fa-asterisk</v-icon>
                </template>
            </v-text-field>

        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field prepend-icon="fa fa-envelope-o" v-model="payer.email" data-vv-validate-on="blur" v-validate="'required|email'" :error-messages="errors.collect('payer.email')" :label="$t('message.email')" data-vv-name="payer.email"
                required>
                <template slot="append-outer">
                    <v-icon v-show="payer.email===undefined?true:(payer.email.length>0?false:true)">fa fa-asterisk</v-icon>
                </template>
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field prepend-icon="fa fa-road" v-model="billing_address.street1" v-validate="'required'" :error-messages="errors.collect('billing_address.street1')" :label="$t('message.address')" data-vv-name="billing_address.street1"
                required>
                <template slot="append-outer">
                    <v-icon v-show="billing_address.street1===undefined?true:(billing_address.street1.length>0?false:true)">fa fa-asterisk</v-icon>
                </template>
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
            <v-text-field prepend-icon="fa fa-phone" v-model="payer.phone" data-vv-validate-on="blur" :mask="masks.phone" v-validate="{required: isPhone, regex:/^(?:\(\d{3}\)|\d{3})\d{3}\d{4}$/}" :error-messages="errors.collect('payer.phone')" :label="$t('message.phone')" data-vv-name="payer.phone" required>
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
            <v-text-field prepend-icon="fa fa-building-o" v-model="billing_address.city" data-vv-validate-on="blur" v-validate="'required|alpha_spaces'" :error-messages="errors.collect('billing_address.city')" :label="$t('message.city')" data-vv-name="billing_address.city" required>
                <template slot="append-outer">
                    <v-icon v-show="billing_address.city===undefined?true:(billing_address.city.length>0?false:true)">fa fa-asterisk</v-icon>
            </template>
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
            <v-text-field prepend-icon="fa fa-map-marker" return-masked-value mask="##########" v-model="billing_address.postal_code" data-vv-validate-on="blur" v-validate="'required|min:3'" :error-messages="errors.collect('billing_address.postal_code')" :label="$t('message.zip')"
                data-vv-name="billing_address.postal_code" required>
                <template slot="append-outer">
                    <v-icon v-show="billing_address.postal_code===undefined?true:(billing_address.postal_code.length>0?false:true)">fa fa-asterisk</v-icon>
                </template>
            </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
            <v-autocomplete persistent-hint prepend-icon="fa fa-globe" :filter="filterSelectInput" v-model="billing_address.country" v-validate="'required'" :items="countries" item-text="name" item-value="code" :error-messages="errors.collect('billing_address.country')" :label="$t('message.country')" data-vv-name="billing_address.country">
                <template slot="append-outer">
                    <v-icon v-show="billing_address.country===undefined?true:(billing_address.country.length>0?false:true)">fa fa-asterisk</v-icon>
                </template>
            </v-autocomplete>
        </v-flex>
    </v-layout>
</v-form>
</template>


<script>

import {
    EventBus
} from './EventBus.js';
export default {
    data() {
        return {
            masks: {
                phone: 'phone',
            },
            payer: {
                full_name: '',
                email: '',
                phone: '',
            },
            billing_address: {
                street1: '',
                city: '',
                country: '',
                postal_code: '',
            },
            isPhone: false,
            countries: [],
        }
    },
    props: { 
        databuyer: { type: Object },
        datalocale: { type: String, default: 'en' },
        post_component:{
            type: Object,
            // Object or array defaults must be returned from
            // a factory function
            default: function () {
                return { buyer: {name:""} }
            }
        },
    },
    mounted() {
        this.$nextTick(function() {
            EventBus.$on('next', this.validateForm);
            EventBus.$on('focus', this.setFocus);
            EventBus.$on('callerData', this.setBuyerData2);
            EventBus.$on('countries', this.setCountries);
            
            console.log("getdatabuyer >>>>>");
            if(this.post_component.hasOwnProperty("buyer")){
                this.setBuyerData(this.post_component.buyer);  
            }
             
            this.setFocus();  

            
            EventBus.$on('resetForm1', this.reset);
      

        });
    },
    watch: {
        'payer.email'(){
            if (this.errors.has('payer.email')) {
              this.errors.remove('payer.email');
          }
        },
        'payer.phone'(){
            if (this.errors.has('payer.phone')) {
              this.errors.remove('payer.phone');
            }
        },
        'billing_address.city'(){
            if (this.errors.has('billing_address.city')) {
              this.errors.remove('billing_address.city')
            }
        }
    },
    methods: {
        validateForm(scope) {
            if (scope == 'form1') {
                console.log(`${scope} == 'form1'`);
                this.$validator.validateAll(scope).then(res => {
                    console.log("validateAll");
                    console.log(res);
                    if (res) {
                        this.$parent.$emit('submit', {
                            form: 'form1',
                            payer: this.payer,
                            billing_address: this.billing_address
                        });
                    }
                });
            }
        },
        setBuyerData(buyer) {
            //const { buyer } = data;
            this.payer.full_name = buyer.name;
            this.payer.email = buyer.email;
            // this.billing_address.street1 = buyer.address;
            // this.billing_address.city = buyer.city;
            this.billing_address.country = buyer.country;
            // this.billing_address.postal_code = buyer.zipCode;
        },
        setBuyerData2(data) {
            console.log("setBuyerData2 >>>>>>>>>>.");
            console.log(data);
            const { buyer } = data;
            this.payer.full_name = buyer.name;
            this.payer.email = buyer.email;
            // this.billing_address.street1 = buyer.address;
            // this.billing_address.city = buyer.city;
            this.billing_address.country = buyer.country;
            // this.billing_address.postal_code = buyer.zipCode;
        },
        setFocus() {
                 
                setTimeout(() => {
                    this.$refs.fullName.focus() !== undefined ? this.$refs.fullName.focus() : console.log('not defined focus');
                }, 300);
             
        },
        reset() {
            console.log("reset >>>>>>>>>>>>>");
            if (this.$refs.form1 !== undefined) {
                console.log('Payment Info defined');
                this.$refs.form1.reset();
            } else {
                console.log('Payment Info not defined');
            }

            this.$validator.reset();
        },
        setCountries(locale,jsonCountries = null) {
            console.log("setCountries");
            console.log(locale);
            if(jsonCountries != null){
                console.log(jsonCountries);
                this.countries = jsonCountries[locale].message;
            }else{
                 this.countries = this.$t(`message.countries.${locale}.message`);
            }
           
        },
        filterSelectInput (item, queryText, itemText) {
          const hasValue = val => val != null ? val : ''

          let text = _.deburr(hasValue(itemText).toString().toLowerCase())
          let query = _.deburr(hasValue(queryText).toString().toLowerCase())

          return text.indexOf(query) > -1;
        }
    }
}
</script>
<style>
.fa-asterisk:before{
  color:red;
  font-size: .35em;
}
</style>
